import { createApiActions } from '@tabeeb/shared/utils/actions'

export const getMaintenanceMessage = createApiActions('GET_MAINTENANCE_MESSAGE')
